import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, FlameIcon, ArrowRightIcon, GamepadIcon } from 'lucide-react';
interface UserRankProps {
  user: {
    name: string;
    avatar: string;
    points: number;
    completedLessons: number;
    streak: number;
    completedGames?: number;
  };
}
export function UserRank({
  user
}: UserRankProps) {
  // Split name by comma to display on two lines
  const nameParts = user.name.split('，');
  return <div className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-125">
      <div className="p-5" data-id="element-126">
        <div className="flex items-center justify-between mb-4" data-id="element-127">
          <h2 className="text-lg font-bold text-gray-800" data-id="element-128">您的学习进度</h2>
          <Link to="/learning" state={{
          autoPlay: true
        }} className="bg-amber-700 active:bg-amber-800 text-white px-4 py-2.5 rounded-xl font-medium flex items-center transition-colors shadow-md active:scale-95" data-id="element-129">
            开始学习
            <ArrowRightIcon size={18} className="ml-2" data-id="element-130" />
          </Link>
        </div>
        <div className="flex items-start mb-5" data-id="element-131">
          <div className="flex flex-col items-center mr-4" data-id="element-132">
            <img src={user.avatar} alt={user.name} className="w-16 h-16 rounded-full object-cover border-4 border-indigo-100" data-id="element-133" />
            <div className="text-center mt-2" data-id="element-134">
              {nameParts.map((part, index) => <p key={index} className="text-sm font-semibold text-gray-800 leading-tight" data-id="element-135">
                  {part}
                </p>)}
            </div>
          </div>
          <div className="flex-1" data-id="element-136">
            <div className="flex flex-wrap gap-2" data-id="element-137">
              <div className="flex items-center bg-indigo-50 px-2.5 py-1.5 rounded-lg" data-id="element-138">
                <div className="w-5 h-5 rounded-full bg-indigo-500 text-white flex items-center justify-center mr-2 text-xs font-bold" data-id="element-139">
                  积
                </div>
                <div data-id="element-140">
                  <p className="text-indigo-700 font-bold text-sm" data-id="element-141">
                    {user.points}
                  </p>
                  <p className="text-indigo-600 text-xs" data-id="element-142">积分</p>
                </div>
              </div>
              <div className="flex items-center bg-emerald-50 px-2.5 py-1.5 rounded-lg" data-id="element-143">
                <BookOpenIcon size={16} className="text-emerald-500 mr-2" data-id="element-144" />
                <div data-id="element-145">
                  <p className="text-emerald-700 font-bold text-sm" data-id="element-146">
                    {user.completedLessons}
                  </p>
                  <p className="text-emerald-600 text-xs" data-id="element-147">课程</p>
                </div>
              </div>
              <div className="flex items-center bg-red-50 px-2.5 py-1.5 rounded-lg" data-id="element-148">
                <FlameIcon size={16} className="text-red-500 mr-2" data-id="element-149" />
                <div data-id="element-150">
                  <p className="text-red-700 font-bold text-sm" data-id="element-151">
                    {user.streak}
                  </p>
                  <p className="text-red-600 text-xs" data-id="element-152">连续天数</p>
                </div>
              </div>
              <div className="flex items-center bg-amber-50 px-2.5 py-1.5 rounded-lg" data-id="element-153">
                <GamepadIcon size={16} className="text-amber-500 mr-2" data-id="element-154" />
                <div data-id="element-155">
                  <p className="text-amber-700 font-bold text-sm" data-id="element-156">
                    {user.completedGames || 0}
                  </p>
                  <p className="text-amber-600 text-xs" data-id="element-157">游戏</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}